import {useState} from 'react';
import {useSelector} from 'react-redux';

import {IFieldMeta, METADATA_MODULE} from 'entities/metadata';
import {setData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch} from 'store/config/hooks';
import {TAppState} from 'store/config/types';

export interface IUseFieldDisabledStateProps {
    entityName?: string;
    isDisabled?: boolean;
    dependentKeys?: string[];
}

export const useFieldDisabling = ({entityName, isDisabled, dependentKeys}: IUseFieldDisabledStateProps) => {
    const dispatch = useAppDispatch();
    const [isDisabledField, setDisabledField] = useState(isDisabled);
    const data: IFieldMeta[] = useSelector(
        (state: TAppState) => state[METADATA_MODULE]?.[entityName!]
            ?.[EEntityType.FORM]?.fields,
    );

    const handleDisabledField = () => {
        dependentKeys?.forEach((key: string) => {
            const newData = data || [];
            const index = data.findIndex(item => key === item?.key);
            const item = newData[index];
            newData.splice(index, 1, {
                ...item,
                isDisabled: isDisabledField,
            });

            dispatch(setData({
                entityName: entityName!,
                entityType: EEntityType.FORM,
                loading: false,
                data: {
                    fields: newData,
                },
            }));
        });
        setDisabledField(!isDisabledField);
    };

    return {handleDisabledField};
};
